import { b2x } from '@b2x/react/src';

import { Page } from './Page';

export interface Error404PageProps {}

export const Error404Page = (props: Error404PageProps) => {
  return (
    <Page>
      <b2x.Div marginY={5} textAlign="center">
        <h2>Error 404</h2>
      </b2x.Div>
    </Page>
  );
};
